import React from 'react'
import { Div } from 'glamorous'
import EmbeddedModal from 'components/modal/EmbeddedModal'

import LoginButton from './LoginButton'

export default class LoginScreen extends React.Component {
  componentDidMount() {
    window.FB.XFBML.parse(this.containerRef)
  }
  render() {
    return (
      <Div
        innerRef={ref => (this.containerRef = ref)}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <EmbeddedModal>
          Login with Facebook to confirm your profile.

          <Div marginLeft={-24} marginRight={-24} marginBottom={-18} marginTop={24}>
            <LoginButton onClick={requestFBLogin} role="button" />
          </Div>
        </EmbeddedModal>
      </Div>
    )
  }
}

const requestFBLogin = () => window.FB.login((response) => {
}, {scope: 'user_link'})



// WEBPACK FOOTER //
// ./src/components/login/LoginScreen.js